import { InfiniteData } from '@tanstack/query-core';

import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { composePaginatedData } from '../utils';

import { fetchRentals } from './fetchRentals';

type GetRentalsArgs = {
  referenceId: string;
  pageSize: number;
};

export function getRentals({ referenceId, pageSize }: GetRentalsArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return undefined;
  }

  const data = queryClient.getQueryData<InfiniteData<Awaited<ReturnType<typeof fetchRentals>>>>(
    queryKeys.rentals(referenceId, pageSize),
  );

  if (!data) {
    return [];
  }

  return composePaginatedData({ data });
}
